import React from 'react';
import ChoiceList from '../../components/nucleus/ChoiceList';
import { realmMeaning } from '../nucleus/groupRealms';

// WHAT THEY CAN DO: one of the group's realms, each with a line on what it
// allows (the three every group has say it in our words; the rest in their own
// description), the three first, as memberRealms sorts them. The invite sheet,
// the change-realm dialog and the demote dialog all pick with it.
export default function RealmChoice({ realms, value, onChange, disabled = false, title, label = 'What they can do', groupName }) {
    return (
        <ChoiceList
            label={label} title={title} disabled={disabled} value={value} onChange={onChange}
            options={realms.map((r) => ({ value: r.id, label: r.name, hint: realmMeaning(r, groupName) }))}
        />
    );
}
